// extracted by mini-css-extract-plugin
module.exports = {"truck":"delivery-truck_truck__9acnb","truckDrive":"delivery-truck_truckDrive__vl8Kx"};